import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage-deep water-glow text-center text-white" aria-label="Limited time offer" data-id="element-267" data-mp="369pga49jt16e">
      <div className="metal-bar h-2 w-full" aria-hidden="true" data-id="element-268" data-mp="31ipjcz0fij3w" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-269" data-mp="31h4p7ai1126k">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-danger" data-id="element-270" data-mp="3g72ho2mzoe1k">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="3b8iujywnsw7m" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5 scale-110" data-id="element-272" data-mp="3p8a4nok21sgc" />
        <p className="mt-7 font-bold text-silver" data-id="element-273" data-mp="3l7hv0u79tljj">After that the price increases and never drops again.</p>

        <div className="panel-dark mx-auto mt-6 max-w-xl rounded-lg border border-silverEdge p-4 text-sm" data-id="element-274" data-mp="1uu94n0crqzeo">
          <p className="font-bold text-silverBright" data-id="element-275" data-mp="1qtz1rwk9wp41">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-danger" data-id="element-276" data-mp="1qva19k6orapc" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/40" data-id="element-277" data-mp="2xtj01vvwtqyz">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="metal-surface h-full rounded-full" data-id="element-278" data-mp="32rkhkcdoti8c" />
          </div>
          <p className="mt-1 text-right text-xs text-silverDark" data-id="element-279" data-mp="3gi7hu8z3jg6j">66% of spots taken</p>
        </div>
      </div>
      <div className="metal-bar h-2 w-full" aria-hidden="true" data-id="element-280" data-mp="3ljn4g5gx9ur1" />
    </section>;
}